<h2 mat-dialog-title>Seleccionar Garantía</h2>
<mat-dialog-content class="guaranty-dialog">
  <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
  <app-data-table
    [rows]="guaranties"
    [columns]="columns"
    [paginatorStatus]="paginatorStatus"
    [externalPagination]="true"
    (updateRows)="updateGuaranties($event)"
    (sortFn)="updateSort($event)">
  </app-data-table>
</mat-dialog-content>

<ng-template #buttonsColumnTemplate let-row="row">
  <div class="table-row-buttons">
    <button mat-raised-button color="primary" (click)="selectWarranty(row)">
      Seleccionar
    </button>
  </div>
</ng-template>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
</mat-dialog-actions>
